import { Share2, Link } from 'lucide-react';
import { toast } from '../utils/toast';

const SHARE_TITLE = 'Talentfunn';
const SHARE_TEXT = 'Norges plattform for talenter og oppdragsgivere. Sjekk ut Talentfunn!';
const TALENTFUNN_URL = 'https://talentfunn.no';

export function ShareTalentfunnBlock() {
  const canNativeShare =
    typeof navigator !== 'undefined' && typeof navigator.share === 'function';

  const handleNativeShare = async () => {
    try {
      await navigator.share({
        title: SHARE_TITLE,
        text: SHARE_TEXT,
        url: TALENTFUNN_URL,
      });
      toast.success('Takk for at du deler!');
    } catch (err) {
      if ((err as Error).name !== 'AbortError') {
        toast.error('Kunne ikke åpne deling');
      }
    }
  };

  const handleCopyLink = async () => {
    const url = TALENTFUNN_URL;
    try {
      await navigator.clipboard.writeText(url);
      toast.success('Lenken er kopiert!');
    } catch {
      toast.error('Kunne ikke kopiere lenke');
    }
  };

  return (
    <div className="flex flex-col gap-3">
      <p className="text-center text-gray-700 font-medium">
        Hjelp oss å nå ut til flere talenter - del Talentfunn med en venn
      </p>
      <div className="flex flex-wrap items-center justify-center gap-3">
        {canNativeShare && (
          <button
            type="button"
            onClick={handleNativeShare}
            className="inline-flex items-center gap-2 px-5 py-3 rounded-xl font-medium bg-gradient-to-r from-purple-600 to-pink-600 text-white shadow-md hover:shadow-lg transition-all"
          >
            <Share2 className="w-5 h-5" />
            Del
          </button>
        )}
        <button
          type="button"
          onClick={handleCopyLink}
          className="inline-flex items-center gap-2 px-5 py-3 rounded-xl font-medium bg-white border-2 border-purple-200 text-purple-700 hover:bg-purple-50 transition-colors"
        >
          <Link className="w-5 h-5" />
          Kopier lenke
        </button>
      </div>
    </div>
  );
}
